import { normalizeOrchestraRole } from 'config/constants/roles';

export function findRoleByValue(roles, roleValue) {
  if (!roleValue || !roles?.length) return null;

  const normalized = normalizeOrchestraRole(roleValue);
  return roles.find((role) => normalizeOrchestraRole(role.value) === normalized) ?? null;
}

export function toTranslatedRoleOption(role, roleValue, t) {
  const source = role ?? { value: roleValue, label: roleValue };
  const labelKey = source.label || source.value;

  return {
    ...source,
    value: source.value ?? roleValue,
    label: t(`useRoles.${labelKey}`),
  };
}

export function getRoleSelectOptions(roles, product, t, selectedRoleValue) {
  const productRoles = roles.filter((role) => role.product === product);
  const options = productRoles.map((role) => ({
    ...role,
    label: t(`useRoles.${role.label}`),
  }));

  if (!selectedRoleValue) return options;

  const selectedExists = options.some(
    (option) => normalizeOrchestraRole(option.value) === normalizeOrchestraRole(selectedRoleValue),
  );
  if (selectedExists) return options;

  const selectedRole = findRoleByValue(productRoles, selectedRoleValue)
    ?? findRoleByValue(roles, selectedRoleValue);

  return [toTranslatedRoleOption(selectedRole, selectedRoleValue, t), ...options];
}
